import React from 'react'
import Select from 'react-select'
import { map, get, some, every, isEmpty, filter } from 'lodash'

const filteredData = ({ hosts, filters }) => filter(hosts, (host) => {
  const filterResults = {}

  if (filters.locations != 'all') {
    filterResults['locations'] = some(filters.locations, location => location.value === get(host, 'location_id'))
  }

  if (filters.powerState != 'all') {
    filterResults['powerState'] = filters.powerState === get(host, 'power_state')
  }

  if (filters.esxi_password_complexity != 'all') {
    filterResults['esxi_password_complexity'] = filters.esxi_password_complexity === get(host, 'esxi_password_complexity')
  }

  if (filters.vmotion_enabled != 'all') {
    filterResults['vmotion_enabled'] = filters.vmotion_enabled === get(host, 'vmotion_enabled')
  }

  if (filters.cluster != 'all') {
    filterResults['cluster'] = some(filters.cluster, ({ value }) => value === get(host, 'cluster'))
  }

  if (filters.dcui_running != 'all') {
    filterResults['dcui_running'] = filters.dcui_running === get(host, 'dcui_running')
  }

  if (filters.shell_running != 'all') {
    filterResults['shell_running'] = filters.shell_running === get(host, 'shell_running')
  }

  if (filters.ntp_running != 'all') {
    filterResults['ntp_running'] = filters.ntp_running === get(host, 'ntp_running')
  }

  if (filters.ntp_configured != 'all') {
    filterResults['ntp_configured'] = filters.ntp_configured === get(host, 'ntp_configured')
  }

  if (filters.snmp_running != 'all') {
    filterResults['snmp_running'] = filters.snmp_running === get(host, 'snmp_running')
  }

  if (filters.ssh_running != 'all') {
    filterResults['ssh_running'] = filters.ssh_running === get(host, 'ssh_running')
  }

  if (filters.mondoo_active != 'all') {
    filterResults['mondoo_active'] = filters.mondoo_active === get(host, 'mondoo_active')
  }

  if (filters.mondoo_vulnerabilities != 'all') {
    filterResults['mondoo_vulnerabilities'] = filters.mondoo_vulnerabilities === get(host, 'mondoo_vulnerabilities')
  }

  return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
})

const HostReportFilters = ({ filters, changeFilters, filterOptions }) => {
  return (
    <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>
      <div className='row'>
        <div className="col">
          Location
          <Select
            id='hostLocationFilter'
            isMulti
            value={filters.locations}
            options={filterOptions.locations}
            onChange={options => {
              let locations = options
              if (isEmpty(options)) { locations = 'all' }

              changeFilters({ ...filters, locations })
            }}
          />
        </div>

        <div className="col">
          Cluster
          <Select
            id='hostClusterFilter'
            isMulti
            value={filters.cluster}
            options={filterOptions.cluster}
            onChange={options => {
              let cluster = options
              if (isEmpty(options)) { cluster = 'all' }

              changeFilters({ ...filters, cluster })
            }}
          />
        </div>
      </div>
    </div>
  )
}

const booleanThFilter = ({ filter, changeFilters, filterName, filters, trueLabel = 'Running', falseLabel = 'Not Running' }) => (
  <select onChange={event => changeFilters({ ...filters, [filterName]: (event.target.value === 'all' ? 'all' : event.target.value === 'true') })} style={{ width: "100%" }}>
    <option value="all" selected={'all'}>Show All</option>
    {map([{ label: trueLabel, value: true }, { label: falseLabel, value: false }], status => (
      <option value={status.value} selected={filter && filter.value === status.value}>{status.label}</option>
    ))}
  </select>
)

export { HostReportFilters, filteredData, booleanThFilter }
